import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Order } from 'src/app/common/event.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cart-info-box',
  templateUrl:  `./${environment.pageFolder}/cart-info-box.${environment.pageFolder}.component.html`,
  styleUrls:  [`./${environment.pageFolder}/cart-info-box.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [CommonModule, TranslateModule]
})

export class CartInfoBoxComponent implements OnInit {
  buyMembership: boolean = false;
  @Input() cart!: Order;
  @Input() pageClass!: string;

  constructor() {}

  ngOnInit(): void {}
}